import { useEffect } from 'react';

/** Dominio base de producción de Huaytanatura */
export const SITE_URL = 'https://huaytanatura.germ4nhyt.site';

const DEFAULT_TITLE =
  'Huaytanatura — Productos Naturales y Harinas Andinas en Ñaña - Chaclacayo, Lima Este';
const DEFAULT_DESCRIPTION =
  'Tienda de productos naturales y harinas andinas en Ñaña - Chaclacayo, Lima Este (Carretera Central). Quinua, maca, granos andinos, frutos secos, aceites y superalimentos 100% naturales. Entregas en Ñaña, Ate, Chaclacayo y Chosica. Pedidos por WhatsApp.';
const DEFAULT_IMAGE = `${SITE_URL}/images/og-default.jpg`;

interface SeoParams {
  /** Título de la pestaña y para redes sociales */
  title?: string;
  /** Meta description de la página */
  description?: string;
  /** Ruta relativa para canonical y og:url (p. ej. "/tienda") */
  path?: string;
  /** Imagen absoluta para OG/Twitter */
  image?: string;
  /** og:type */
  type?: string;
}

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.rel = 'canonical';
    document.head.appendChild(el);
  }
  el.href = href;
}

/**
 * Sincroniza el `<title>`, meta description, canonical y etiquetas
 * OG/Twitter de la página actual. Pensado para SPA con React Router,
 * donde el HTML estático de index.html no puede variar por ruta.
 */
export function useSeo({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  path = '/',
  image = DEFAULT_IMAGE,
  type = 'website',
}: SeoParams = {}) {
  useEffect(() => {
    const url = `${SITE_URL}${path}`;

    document.title = title;

    upsertMeta('name', 'description', description);
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:type', type);
    upsertMeta('property', 'og:url', url);
    upsertMeta('property', 'og:image', image);
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);
    upsertMeta('name', 'twitter:image', image);

    upsertCanonical(url);
  }, [title, description, path, image, type]);
}